import type { PAGE_POSITIONS } from 'types';
import type { AffiliateStockListing, CapiProductPage } from 'types/capi/pdp';

import type { Variant } from '~/components/Button';
import AffiliateLogo from '~/components/Pdp/WhereToBuyInStock/AffiliateLogo';
import usePageData from '~/hooks/usePageData';

import AffiliateProductLink from '../../AffiliateProductLink';

type Props = {
  buttonPosition: number;
  isDarkBg?: boolean;
  pagePosition: PAGE_POSITIONS;
  selectedSize?: string;
  showAfffiliateLogo?: boolean;
  stockListing: AffiliateStockListing;
  variant?: Variant;
};

export const BuyNow = ({
  stockListing,
  buttonPosition,
  pagePosition,
  showAfffiliateLogo,
  selectedSize,
  variant = 'forest'
}: Props) => {
  const product = usePageData<CapiProductPage>();

  return (
    <AffiliateProductLink
      urlTemplates={stockListing}
      affiliate={stockListing.affiliate}
      price={stockListing.price}
      product={product}
      selectedSize={selectedSize}
      buttonPosition={buttonPosition}
      pagePosition={pagePosition}
      variant={variant}
    >
      <div className="flex h-8 items-center justify-center gap-2">
        <div className="flex items-center gap-2 text-base">
          {showAfffiliateLogo && (
            <div className="m-auto flex size-7 items-center rounded-md bg-white p-[0.05rem]">
              <AffiliateLogo
                src={stockListing.affiliate.logo}
                alt={stockListing.affiliate.name}
              />
            </div>
          )}
          <span>
            {`Buy from ${
              stockListing.affiliate.id === 'affiliate:marketplace'
                ? 'our marketplace'
                : stockListing.affiliate.name
            }`}
          </span>
        </div>
      </div>
    </AffiliateProductLink>
  );
};

export const VisitSite = ({
  stockListing,
  buttonPosition,
  pagePosition
}: Props) => {
  const product = usePageData<CapiProductPage>();

  return (
    <AffiliateProductLink
      product={product}
      buttonPosition={buttonPosition}
      pagePosition={pagePosition}
      urlTemplates={stockListing}
      affiliate={stockListing.affiliate}
      price={stockListing.price}
      variant="white"
    >
      <div className="flex h-full items-center justify-center gap-2">
        Visit Site
      </div>
    </AffiliateProductLink>
  );
};

export default {
  BuyNow,
  VisitSite
};
